import { Component, Optional, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './components/core/header/header';
import { AppMenu } from './components/core/menu/menu';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastContainer } from './components/core/toast/toast';
import { BusinessPartnersService } from './common/services/business-partners.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, AppMenu, TranslateModule, ToastContainer],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('copilot-admin-ui');
  protected readonly sidebarCollapsed = signal<boolean>(false);

  constructor(
    private translate: TranslateService,
    @Optional() private businessPartnersService: BusinessPartnersService | null
  ) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    this.businessPartnersService?.initialize();
  }

  protected toggleSidebar(): void {
    this.sidebarCollapsed.update((prev) => !prev);
  }

  protected isSidebarCollapsed(): boolean {
    return this.sidebarCollapsed();
  }
}
